module.exports = __webpack_public_path__ + "static/media/  (77).5f4a13a2.jpg";